import React, { useContext } from 'react'
import { Link } from 'react-router'
import Navigation from '@App/navigation'
import { UserGroup } from '@Entities/user/user'
import { getDateFromIso } from '@App/helpers/get-date-iso-6801'
import Button from '@Components/Buttons/Button'
import { StoresContext } from '@App/contexts'
import RootStore from '@App/stores/root-store'
import { observer } from 'mobx-react'

interface ConfirmedNewUserStepProps {
    destroyForm: () => void
}

const ConfirmedNewUserStep = ({ destroyForm }: ConfirmedNewUserStepProps) => {
    const { rightsholderUserStore, rightsholderStore } = useContext<RootStore>(StoresContext)

    const inviteInfo = rightsholderUserStore.rightsholderUserInviteInfo

    if (!inviteInfo) {
        return null
    }

    return (
        <div className="add-new-user-sub-form-component">
            <h2>Invite Sent!</h2>
            <h5 className="medium subtitle">An invite to the portal has been sent to the email address provider</h5>
            <br />
            <h5>Invited user</h5>
            <div className="invited-user-card">
                <div className="head">
                    <div>
                        <h5 title={inviteInfo.firstName + ' ' + inviteInfo.lastName}>
                            {inviteInfo.firstName} {inviteInfo.lastName}
                        </h5>
                        <p title={inviteInfo.email} className="small">
                            {inviteInfo.email}
                        </p>
                    </div>
                    {inviteInfo.exposedId && (
                        <Link
                            to={Navigation.rightholder.maintenance.userPermissionsProfile(
                                rightsholderStore.currentRightsholderId,
                                inviteInfo.exposedId
                            )}
                            className="blue-text link"
                        >
                            View
                        </Link>
                    )}
                </div>
                <div className="info-block">
                    <div>
                        <p className="small bold">GROUP</p>
                        {inviteInfo &&
                            inviteInfo.groups &&
                            inviteInfo.groups.map((item: UserGroup) => (
                                <p key={item.name} className="small">
                                    {item.name}
                                </p>
                            ))}
                    </div>
                    <div>
                        <p className="small bold">STATUS</p>
                        <p className="small">{inviteInfo.verificationStatus}</p>
                    </div>
                    {inviteInfo.invitedAt ? (
                        <div>
                            <p className="small bold">DATE SENT</p>
                            <p className="small">{getDateFromIso(inviteInfo.invitedAt)}</p>
                        </div>
                    ) : null}
                </div>
            </div>
            <Button mainColor type="primary" onClick={destroyForm}>
                Add another user
            </Button>
        </div>
    )
}

export default observer(ConfirmedNewUserStep)
